import { Observable, map } from 'rxjs';

import { PutWishlistRequest } from '../../domain/models/api-wishlist.models';
import { ApiWishlist, WLItem, Wishlist } from '../../domain/models/wishlist.models';
import { WishlistApiRepository } from '../../infrastructure/api/wishlist.api.repository';
import { WishlistModelsTransformer } from '../transformers/wishlist.transformer';

import { StoreAndLanguage } from '@core/domain/state/core.state';

export function DeleteItemWishlistUseCase$(
    wishlistApiRepository: WishlistApiRepository,
    name: string,
    wishlist: Wishlist,
    itemToDelete: WLItem,
    storeAndLanguage: StoreAndLanguage,
    catalogId?: string,
    whislistUrl?: string
): Observable<ApiWishlist> {
    const filteredItems: WLItem[] = wishlist.items
        .filter(e => e?.status?.selectedSize?.sku?.toString() !== itemToDelete.catentryId)
        .map(e => ({
            catentryId: e?.status?.selectedSize?.sku,
            productId: e?.id,
            quantity: undefined,
        }));

    const body: PutWishlistRequest = { wlArray: [{ name, items: filteredItems }] };

    return wishlistApiRepository.putWishlist(
        storeAndLanguage.storeId,
        storeAndLanguage.languageId,
        catalogId,
        body,
        whislistUrl
    ).pipe(
        map((data) => WishlistModelsTransformer.WishlistPutResponse(data, name)),
    );
}
